<template>
	<div>
		<div class="m-top flex-between-center" :style="{'z-index': showViewList ? 1010 : 90}">
			<div v-show="!searchState" class="view flex-center-cross" @click="viewListHandle">
				<span>{{currentView.view_name}}</span>
				<i v-if="viewList.length > 1" class="tf">&#xe736;</i>
			</div>
			<div v-if="search" v-show="searchState" class="search flex-grow flex-center">
				<div class="input flex-center flex-grow">
					<i class="tf-search"></i>
					<input v-model="searchValue" ref="searchInput" class="flex-grow" :placeholder="serachConfig.placeholder">
				</div>
				<a class="cancel" @click="searchHandle(false)">取消</a>
			</div>
			<div class="handle flex">
				<div v-if="search && !showViewList" v-show="!searchState" class="item flex-center" @click="searchHandle(true)"><i class="tf-search"></i></div>
				<div v-if="filter && !showViewList" class="item flex-center" @click="filterHandle(true)">
					<i class="tf">&#xe60b;</i>
					<span v-if="effectFilterCount > 0">{{effectFilterCount}}</span>
				</div>
			</div>
		</div>

		<c-scroll-view v-if="tabList && tabList.length" class="m-tab" scroll-x>
			<ul class="flex">
				<li v-for="(item, i) in tabList" :key="i" class="flex-center" :class="{'z-crt': currentTabId === item.value}" @click="tabHandle(item)">
					<span>{{item.name}}{{item.value !== '' && tabTotal ? ` (${tabTotal[item.value] || 0})` : ''}}</span>
				</li>
			</ul>
		</c-scroll-view>

		<c-dialog v-if="viewList.length > 1" ref="viewList" position="top" :title="false" mask-close :close-button="false" :button="false" @close="viewListClose">
			<c-scroll-view class="view-list">
				<ul>
					<li v-for="(item, i) in viewList" :key="i" @click="viewHandle(item)" class="flex-between-center" :class="{'z-crt': currentViewId == item.id}">
						<span>{{item.view_name}}</span>
						<i class="check tf">&#xe65e;</i>
					</li>
				</ul>
			</c-scroll-view>
		</c-dialog>

		<c-dialog v-if="filter" ref="filter" position="right" title="筛选" width="94%" mask-close>
			<slot name="filter"></slot>
			<template #button>
				<c-button size="dialog" @click="$search && $search.clear()">重置</c-button>
				<c-button size="dialog" color="main" @click="$search && $search.search()">确定</c-button>
			</template>
		</c-dialog>
	</div>
</template>

<script>
	import dictList from '@/store/dict.js'

	export default {
		name: 'topbar',

		props: {
			workType: [String, Number],
			customView: Object,
			search: {
				type: [Boolean, Object],
				default: true
			},
			filter: {
				type: Boolean,
				default: true
			}
		},

		data() {
			let storage = JSON.parse(localStorage.getItem(this.workType) || '{}');
			return {
				showViewList: false,
				viewList: [],
				currentViewId: storage.v || '',
				tabList: null,
				tabTotal: null,
				currentTabId: storage.g === 0 ? 0 : storage.g || '',
				searchState: !!storage.k,
				searchValue: storage.k || '',
				filterParam: {}
			}
		},

		computed: {
			currentView() {
				return this.customView ? {view_name: this.customView.name} : this.viewList.find(item => item.id == this.currentViewId) || {};
			},

			params() {
				return Object.assign({
					view_id: this.currentViewId || undefined,
					second_filter_value: this.customView ? '' : this.currentTabId,
					keyword: this.searchValue.trim()
				}, this.filterParam, this.customView && this.customView.tabParam ? this.customView.tabParam(this.currentTabId) : {});
			},
			
			serachConfig() {
				return Object.assign({
					placeholder: '搜索关键字'
				}, this.search);
			},

			effectFilterCount() {
				return Object.keys(this.filterParam).filter(key => {
					if (key == 'user_filter_condition') return false;
					if (Array.isArray(this.filterParam[key])) {
						return this.filterParam[key].length;
					} else if (typeof this.filterParam[key] == 'string') {
						return this.filterParam[key].trim();
					} else {
						return this.filterParam[key] || this.filterParam[key] === 0;
					}
				}).length + (this.filterParam['user_filter_condition'] ? this.filterParam['user_filter_condition'].length : 0);
			}
		},

		watch: {
			searchValue() {
				clearTimeout(this._searchTimer);
				this._searchTimer = setTimeout(() => {
					this.$emit('update', this.params);
				}, 500);
			},

			params(val) {
				this.workType && localStorage.setItem(this.workType, JSON.stringify({
					v: val.view_id,
					g: val.second_filter_value,
					k: val.keyword
				}));
			}
		},

		mounted() {
			this.workType && this.request({
				url: '/sys_user_view/list',
				data: {
					work_type_id: this.workType
				},
				success: data => {
					this.$emit('empty', !data.length);
					this.viewList = data;
					let index = this.viewList.findIndex(item => item.id == this.currentViewId);
					this.viewHandle(data[index == -1 ? 0 : index]);
				}
			});

			if (this.customView && this.customView.tabs) {
				this.tabList = [{name: '全部', value: ''}].concat(this.customView.tabs);
				this.tabHandle(this.tabList[0]);
			}
			
			if (this.filter) {
				this.$nextTick(() => {
					this.$search = this.$refs.filter.$children.find(item => item.$options.name == 'mSearch');
					if (this.$search) {
						this.filterParam = this.$search.get();
						this.$search.viewListHandle = data => {
							this.$refs.filter.close();
							this.filterParam = data;
							this.$emit('update', this.params);
						};
					}
				})
			}
		},

		methods: {
			viewListHandle() {
				if (this.viewList.length <= 1) return;
				if (this.showViewList) {
					this.$refs.viewList.close();
				} else {
					this.showViewList = true;
					this.$refs.viewList.open({
						zIndex: this.showViewList ? 1009 : 89
					});
				}
			},

			viewListClose() {
				setTimeout(() => {
					this.showViewList = false;
				}, 410);
			},

			viewHandle(view) {
				if (!view) return;
				this.$refs.viewList && this.$refs.viewList.close();
				this.currentViewId = view.id;
				this.request({
					url: '/sys_user_view/config',
					data: {
						view_id: view.id
					},
					success: data => {
						if (data.second_config.fieldId) {
							if (data.second_config.dictOptions) {
								this.tabList = [{name: '全部', value: ''}].concat(data.second_config.dictOptions);
							} else if (data.second_config.dictName && dictList[data.second_config.dictName]) {
								this.tabList = [{name: '全部', value: ''}].concat(dictList[data.second_config.dictName]);
							} else {
								this.tabList = [];
							}
						} else {
							this.tabList = [];
						}
						this.tabTotal = null;
						let index = this.tabList.findIndex(item => item.value === this.currentTabId);
						this.tabHandle(this.tabList[index == -1 ? 0 : index] || {})
					}
				});
			},

			tabHandle(tab) {
				this.currentTabId = tab.value === 0 ? 0 : tab.value || '';
				this.$emit('update', this.params);
			},

			updateTabTotal(url) {
				if (!this.customView && this.tabList.length) {
					this.request({
						url: `${url}/groupCount`,
						data: Object.assign({
							view_id: this.currentViewId
						}, this.params),
						success: data => {
							if (data) {
								this.tabTotal = {};
								data.forEach(item => {
									this.tabTotal[item.value] = item.count;
								});
							} else {
								this.tabTotal = null;
							}
						},
						fail: () => {
							return false;
						}
					});
				}
			},

			searchHandle(state) {
				this.searchState = state;
				this.searchValue = '';
				if (state) {
					this.$nextTick(() => {
						this.$refs.searchInput.focus();
					})
				}
			},

			filterHandle() {
				this.$search.reset();
				this.$refs.filter.open();
			}
		}
	};
</script>

<style lang="stylus" scoped>
	.m-top {
		position: relative;
		height: .94rem;
		padding: 0 .26rem;
		background: #fff;

		.search {
			height: .94rem;
			padding-right: .2rem;

			.input {
				box-sizing: border-box;
				height: .68rem;
				border-radius: .36rem;
				padding: 0 .3rem;
				font-size: .32rem;
				color: #bbb;
				background: #F9F9F9;

				input {
					height: 100%;
					margin-left: .18rem;
					font-size: .3rem;
				}
			}

			.cancel {
				margin-left: .26rem;
				font-size: .28rem;
			}
		}

		.handle {
			gap: .2rem;

			.item {
				position: relative;
				width: .6rem;
				height: .6rem;
				font-size: .4rem;
				color: #333;

				span {
					position: absolute;
					right: 0;
					bottom: .1rem;
					box-sizing: border-box;
					min-width: .28rem;
					padding: 0 .06rem;
					border-radius: .14rem;
					line-height: .28rem;
					font-size: .2rem;
					text-align: center;
					color: #fff;
					background: #FFA82B;
				}
			}
		}
	}

	.m-tab {
		background: #fff;

		ul {
			gap: .18rem;
			float: left;
			padding: 0 .26rem .2rem;

			li {
				box-sizing: border-box;
				min-width: 1.46rem;
				height: .64rem;
				border-radius: .32rem;
				padding: 0 .26rem;
				font-size: .3rem;
				white-space: nowrap;
				color: #666;
				background: #F5F5F5;

				&.z-crt {
					color: #fff;
					background: var(--color-main);
				}
			}
		}
	}

	.view {
		height: 100%;

		&-list {
			max-height: 80vh;
			border-top: 1px solid #ddd;
			border-radius: 0 0 .2rem .2rem;
			margin-top: .94rem;

			ul {
				padding-bottom: .32rem;

				li {
					height: .88rem;
					padding: 0 .4rem;
					font-size: .32rem;

					&.z-crt {
						color: var(--color-main);
					}

					&:nth-child(even) {
						background: #F9F9F9;
					}

					.check {
						display: none
						font-size: .36rem;
						color: var(--color-main);

						^[-1].z-crt ^[-1..-1] {
							display: block;
						}
					}
				}
			}
		}

		span {
			margin-right: .08rem;
			font-size: .36rem;
			font-weight: bold;
		}
	}
</style>
